import { Route } from 'react-router-dom';
import { RedirectWithCurrentParams } from '@hotjar/webapp/utils/routing';

/**
 * Global redirect from all the routes that contain /workspaces to the up to date routes
 * without workspaces (after workspaces retirement).
 * We want to keep this around while we don't have a better UX for people that have bookmarked their old
 * workspaces pages. This way we avoid them to hit a 404 or blank page without further explanation.
 */
export const WorkspaceToNonWorkspaceRoutes = (): JSX.Element => (
  <Route
    path={'/sites/:siteId/workspaces/:workspaceId/*'}
    element={<RedirectWithCurrentParams to={'/sites/:siteId/*'} />}
  />
);
